<template>
  <div>
    <vs-input class="w-full" v-model="dataLocal.count" label-placeholder="绑卡后赠金 (元)" />
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: String,
      default: '{}'
    }
  },
  data() {
    return {
      dataLocal: {}
    }
  },
  methods: {
    getParam() {
      return JSON.stringify(this.dataLocal)
    }
  },
  mounted() {
    this.dataLocal = JSON.parse(this.data)
  }
}
</script>
